// chats.reducer.ts
import { createReducer, on } from "@ngrx/store";
import { ChatUser, Message } from "./chats.model";
import { loadChatUsers, loadChatUsersSuccess, loadChatUsersFailure, loadMessages, loadMessagesSuccess, loadMessagesFailure, addMessage, setCurrentChatUser } from "./chats.action";

export interface ChatState {
  users: ChatUser[];
  currentUser: ChatUser | null;
  messages: Message[];
  usersLoading: boolean;
  messagesLoading: boolean;
  loading: boolean;
  error: string | null;
}

export const initialState: ChatState = {
  users: [],
  currentUser: null,
  messages: [],
  usersLoading: false,
  messagesLoading: false,
  loading: false,
  error: null
};

export const chatReducer = createReducer(
  initialState,

  on(loadChatUsers, (state) => ({
    ...state,
    usersLoading: true,
    error: null
  })),
  on(loadChatUsersSuccess, (state, { users }) => ({
    ...state,
    users,
    usersLoading: false
  })),
  on(loadChatUsersFailure, (state, { error }) => ({
    ...state,
    usersLoading: false,
    error
  })),

  on(loadMessages, (state) => ({
    ...state,
    messagesLoading: true,
    error: null
  })),
  on(loadMessagesSuccess, (state, { messages }) => ({
    ...state,
    messages,
    messagesLoading: false
  })),
  on(loadMessagesFailure, (state, { error }) => ({
    ...state,
    messagesLoading: false,
    error
  })),

  // Message operations - prevent duplicates
  on(addMessage, (state, { message }) => {
    // Check if message already exists to prevent duplicates
    const messageExists = state.messages.some(existingMessage =>
      existingMessage.senderId === message.senderId &&
      existingMessage.receiverId === message.receiverId &&
      existingMessage.messageText === message.messageText &&
      existingMessage.timestamp === message.timestamp
    );

    if (messageExists) {
      return state; // Don't add duplicate
    }

    return {
      ...state,
      messages: [...state.messages, message]
    };
  }),

  // Current user
  on(setCurrentChatUser, (state, { user }) => {
    console.log('[chatReducer] setCurrentChatUser:', user);
    return {
      ...state,
      currentUser: user // Always update, even if user is not in users list
    };
  })
);
